import { useId } from 'react';

export default function CurvedCorner({
  theme = 'LIGHT',
  corner = 'bottom-right',
  shadowColor,
}: {
  theme?: 'LIGHT' | 'DARK';
  corner?: 'bottom-right' | 'bottom-left' | 'top-right' | 'top-left';
  shadowColor?: string;
}) {
  const isLight = theme === 'LIGHT';
  const uniqueId = useId().replace(/:/g, '-'); // Generate unique ID and replace colons for CSS class names

  const positions = {
    'bottom-right': { vertical: 'bottom: 0;', horizontal: 'right: 0;', shadow: '12px 12px' },
    'bottom-left': { vertical: 'bottom: 0;', horizontal: 'left: 0;', shadow: '-12px 12px' },
    'top-right': { vertical: 'top: 0;', horizontal: 'right: 0;', shadow: '12px -12px' },
    'top-left': { vertical: 'top: 0;', horizontal: 'left: 0;', shadow: '-12px -12px' },
  };

  const { vertical, horizontal, shadow } = positions[corner as keyof typeof positions];
  const className = `curved-corner-${uniqueId}`;

  // Use custom shadowColor if provided, otherwise use default based on theme
  const shadowColorValue =
    shadowColor || (isLight ? 'rgba(31, 31, 31, 0.03)' : 'rgba(255, 255, 255, 0.1)');

  return (
    <>
      <style>{`
        .${className} {
          width: 100%;
          height: 100%;
          overflow: hidden;
          position: relative;
        }

        .${className}:before {
          content: "";
          display: block;
          width: 200%;
          height: 200%;
          position: absolute;
          border-radius: 50%;
          ${vertical}
          ${horizontal}
          box-shadow: ${shadow} 0 0 ${shadowColorValue};
        }
      `}</style>

      <div className={className}></div>
    </>
  );
}
